/**
 * Rejestracja service workera i zgłoszenie gotowej aktualizacji.
 *
 * Cały import modułu wirtualnego `virtual:pwa-register` jest zamknięty w tym
 * jednym pliku. Reszta aplikacji nie zna wtyczki, a testy nie muszą udawać
 * modułu, którego nie ma na dysku.
 *
 * Tryb `prompt` zamiast `autoUpdate`: nowa paczka czeka, aż użytkownik
 * potwierdzi przeładowanie. Podmiana kodu w trakcie wypełniania formularza
 * skończyłaby się utratą tego, co ktoś właśnie wpisywał.
 */

import { registerSW } from 'virtual:pwa-register'

/** Jak często prosimy przeglądarkę o sprawdzenie nowej paczki. */
const CO_ILE_MS = 5 * 60 * 1000

export interface Aktualizacja {
  /** Aktywuje nową paczkę i przeładowuje stronę. */
  zastosuj: () => void
}

/**
 * Podpina nasłuch aktualizacji. Zwraca funkcję odpinającą.
 *
 * `onNowa` dostaje uchwyt pozwalający przeładować aplikację na żądanie.
 * W przeglądarce bez service workera (zwykłe HTTP poza `localhost`) nic się
 * nie stanie — od tego jest odpytywanie `version.json`.
 */
export function nasluchujAktualizacji(onNowa: (aktualizacja: Aktualizacja) => void): () => void {
  let timer: number | undefined

  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      onNowa({ zastosuj: () => void updateSW(true) })
    },
    onRegisteredSW(_url, registration) {
      // Bez tego przeglądarka sprawdza nową paczkę głównie przy nawigacji,
      // a karta otwarta przez cały dzień roboczy nigdy by o niej nie usłyszała.
      if (!registration) return
      timer = window.setInterval(() => void registration.update(), CO_ILE_MS)
    },
  })

  return () => {
    if (timer !== undefined) window.clearInterval(timer)
  }
}
